import { vectorTileRegistry } from "../apis/VectorTileRegistry";

// Sources of every vector-tile layer registered in the app
const vectorSources = () =>
  new Set(
    Object.values(vectorTileRegistry).map((c) => c.sourceId || c.id),
  );

const isBuilding = (l) => /building/i.test(l.id) || /building/i.test(l.source ?? "");

/**
 * Stack, from BOTTOM to TOP. First matching group wins.
 * ADJUST the "viewed-" prefix and the "real-polygon"/"sim-polygon" ids
 * to whatever your polygonLayers.js / viewedlayers.js actually use.
 */
const buildGroups = () => {
  const vt = vectorSources();
  return [
    // 0. historic analysis polygons (fires + saved zone): always at the very bottom
    (l) => l.id.startsWith("viewed-") && !isBuilding(l),
    // 1. current saved zone
    (l) => l.source === "impact-saved-zone",
    // 2. current real fire / simulated fire
    (l) => l.id.startsWith("real-polygon"),
    (l) => l.id.startsWith("sim-polygon"),
    // 3. vector tile layers (buildings tiles, etc.)
    (l) => vt.has(l.source),
    // 4. historic saved / burned buildings
    (l) => l.id.startsWith("viewed-") && isBuilding(l),
    // 5. current saved / burned buildings (+ their ▼ dots): always on top
    (l) =>
      l.source === "impact-saved-buildings" ||
      l.source === "impact-burned-buildings",
  ];
};

export const applyLayerOrder = (map) => {
  if (!map || !map.getStyle?.()) return;
  const layers = map.getStyle().layers ?? [];
  const groups = buildGroups();
  const placed = new Set();

  // moving each group to the top, in order, produces the final stack
  groups.forEach((match) => {
    layers
      .filter((l) => !placed.has(l.id) && match(l))
      .forEach((l) => {
        placed.add(l.id);
        if (map.getLayer(l.id)) map.moveLayer(l.id);
      });
  });
};

// kept so the old import doesn't break
export const reorderVectorTileLayers = (map) => applyLayerOrder(map);